<div class="list">
  <coa-dashboard-floors-list
    *ngIf="showList$ | async"
    [clientId]="clientId"
    [dateRange]="dateRange"
    [elements]="(floorsResponse$ | async)?.content"
    class="dashboard-floors-list">
  </coa-dashboard-floors-list>

  <coa-dashboard-floors-skeleton
    *ngIf="showSkeleton$ | async"
    class="dashboard-floors-skeleton">
  </coa-dashboard-floors-skeleton>

  <coa-dashboard-floors-show-all
    *ngIf="showShowAll$ | async"
    [categoryId]="categoryId"
    [clientId]="clientId"
    [dateRange]="dateRange"
    class="dashboard-floors-show-all">
  </coa-dashboard-floors-show-all>

  <coa-dashboard-floors-error
    *ngIf="showError$ | async"
    class="dashboard-floors-error">
  </coa-dashboard-floors-error>

  <coa-dashboard-floors-empty
    *ngIf="showEmpty$ | async"
    class="dashboard-floors-empty">
  </coa-dashboard-floors-empty>
</div>
